import { Link, useLocation, useNavigate } from "react-router";
import { ActionButton, IconPersonFill } from "@hamlak/ui";
import logoUrl from "@hamlak/ui/brand/logo.svg";
import { t } from "@/i18n/ko";
import { useAuthStore } from "@/stores/authStore";
import { useUiStore } from "@/stores/uiStore";
import { onboardingStep } from "@/app/onboarding";
import { loginModalState } from "@/app/layout/backdrop";
import "./gnb.css";

/**
 * PC 웹 상단 GNB(시안 596:4501, large 전용): 로고 · 홈 · 대화 · 오른쪽 [로그인] 또는 프로필 원(→ /me). 하단 탭을 대신한다.
 * 온보딩 미완 세션은 회원이 아니므로 [로그인]을 보인다(AC0-149 과 같은 기준).
 */
export function Gnb() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const isMember = useAuthStore((s) => s.status === "member" && onboardingStep(s.user) === null);
  const photoUrl = useAuthStore((s) => s.account?.photoUrl);
  const requestLogin = useUiStore((s) => s.requestLogin);
  // 시안: 플롯 프로필·채팅방·상점·마이페이지 프레임에서도 '홈'이 현재 메뉴. '대화'는 /chats 일 때만
  const current = pathname === "/chats" ? "chats" : "home";

  return (
    <header className="gnb">
      <div className="gnb__inner">
        <Link to="/home" className="gnb__logo" aria-label={t("app.name")}>
          <img src={logoUrl} alt="" height={24} />
        </Link>
        <nav className="gnb__nav">
          <Link to="/home" className="gnb__link" aria-current={current === "home" ? "page" : undefined}>
            {t("nav.home")}
          </Link>
          <Link to="/chats" className="gnb__link" aria-current={current === "chats" ? "page" : undefined}>
            {t("nav.chats")}
          </Link>
        </nav>
        <div className="gnb__spacer" />
        {isMember ? (
          <Link to="/me" className="gnb__profile" aria-label={t("nav.me")}>
            {photoUrl ? <img src={photoUrl} alt="" /> : <IconPersonFill size={20} data-testid="gnb-avatar-placeholder" aria-hidden />}
          </Link>
        ) : (
          <ActionButton
            size="medium"
            className="gnb__login"
            onClick={() => {
              requestLogin({ returnTo: pathname });
              navigate("/login", { state: loginModalState(location) });
            }}
          >
            {t("page.login")}
          </ActionButton>
        )}
      </div>
    </header>
  );
}
